import React, { Component } from 'react'
import Mainsec from '../coursetemplate/mainsec'
import Syllabus from '../coursetemplate/syllabus'
import Coursereview from '../coursetemplate/Course-review'
import Overview from '../coursetemplate/overview'
import Coursefeature from '../coursetemplate/coursefeature'
import Batchtime from '../coursetemplate/batchtime'
import Relatedcourse from '../coursetemplate/other-course'
import LearnSoftLogo from '../coursetemplate/CourseLogo'
import CourseEligibility from '../coursetemplate/Course-Eligibility'
import EnrollnowBox from '../coursetemplate/enroll-box'
import Faqs from '../coursetemplate/faq'
import NewMainsec from '../coursetemplate/new-mainsec'
export default class Vuetemplate extends Component {
 
  render() {
    const course =[
      {
        title: "Introduction to Vue.js",
        content: [
          "Overview of Vue.js",
          "Setting up a Vue.js development environment",
          "Vue.js templates",
          "Vue.js directives",
          "Vue.js components"
        ]
      },
      {
        title: " Data Binding",
        content: [
          "Understanding data binding in Vue.js",
          "Two-way data binding in Vue.js",
          "Computed properties in Vue.js",
          "Watchers in Vue.js",
          "Dynamic classes and styles in Vue.js"
        ]
      },
      {
        title: " Directives and Components",
        content: [
          "Understanding directives in Vue.js",
          "v-if and v-show directives in Vue.js",
          "v-for directive in Vue.js",
          "Creating custom directives in Vue.js",
          "Creating custom components in Vue.js"
        ]
      },
      {
        title: " Routing",
        content: [
          "Overview of Vue.js routing",
          "Setting up Vue.js routes",
          "Navigating between routes in Vue.js",
          "Passing parameters to routes in Vue.js",
          "Route guards in Vue.js"
        ]
      },
      {
        title: " Forms and Validation",
        content: [
          "Binding form data in Vue.js",
          "Handling form submissions in Vue.js",
          "Form validation in Vue.js",
          "Using third-party form libraries in Vue.js",
          "Handling form reset in Vue.js"
        ]
      },
      {
        title: "State Management",
        content: [
          "Introduction to Vuex state management",
          "Creating and accessing a Vuex store",
          "Mutations and actions in Vuex",
          "Getters in Vuex",
          "Modules in Vuex"
        ]
      },
      {
        title: "Animations and Transitions",
        content: [
          "Overview of Vue.js animations",
          "Transition classes in Vue.js",
          "Animation classes in Vue.js",
          "Animating lists in Vue.js",
          "Animating between routes in Vue.js"
        ]
      },
      {
        title: "Testing",
        content: [
          "Introduction to testing in Vue.js",
          "Unit testing Vue.js components",
          "Integration testing in Vue.js",
          "Using test runners in Vue.js",
          "Mocking API requests in Vue.js tests"
        ]
      },
      {
        title: "Plugins and Libraries",
        content: [
          "Overview of Vue.js plugins and libraries",
          "Using Vue.js with Bootstrap",
          "Using Vue.js with Axios",
          "Using Vue.js with Firebase",
          "Creating custom Vue.js plugins"
        ]
      },
      {
        title: "Server-Side Rendering",
        content: [
          "Introduction to server-side rendering in Vue.js",
          "Setting up a Vue.js SSR project",
          "Creating SSR-ready Vue.js components",
          "Optimizing Vue.js SSR performance",
          "Using Vuex with Vue.js SSR"
        ]
      },
      {
        title: "Deployment",
        content: [
          "Preparing a Vue.js application for deployment",
          "Deploying a Vue.js application to a server",
          "Deploying a Vue.js application to a CDN",
          "Using Docker with Vue.js",
          "Configuring continuous deployment with Vue.js"
        ]
      },
    ]

    const faqData = [
      {
        question: 'What is Vue.js Training?',
        answer:
          'Vue.js Training is a specialized program designed to teach individuals how to develop dynamic and interactive web applications using the Vue.js framework',
      },
      {
        question: 'Why is Vue.js Training important?',
        answer:
          'Vue.js Training is essential for individuals looking to enhance their skills in front-end development, as Vue.js is one of the fastest-growing JavaScript frameworks widely used in the industry',
      },
      {
        question: 'What topics are covered in Vue.js Training at the best training centre?',
        answer:
          'Vue.js Training at the best training centre covers a wide range of topics, including Vue.js basics, component-based architecture, state management with Vuex, routing with Vue Router, and advanced Vue.js concepts',
      },
      {
        question: 'What career opportunities are available for someone with UI UX Design skills?',
        answer:
          'A person with Vue.js skills can pursue a variety of career opportunities such as Front-end Developer, Web Developer, UI/UX Designer, and Full-stack Developer.',
      },
      {
        question: 'Is there a certificate of completion offered for the courses on Learnsoft.org?',
        answer:
          'Yes, upon completion of a course on Learnsoft.org, students will receive a certificate of completion that can be added to their professional portfolio or resume.',
      },
    ];
    const EligibilityData=[
      {
        cnt:"Embark on a transformative journey into Vue.js at the Best Training Centre. Our comprehensive Vue.js training program welcomes learners from diverse backgrounds, regardless of prior experience with front-end development. Whether you're a web developer, a programming enthusiast, or someone eager to master modern JavaScript frameworks, our courses cater to individuals at every skill level. With a focus on practical application and hands-on learning, our expert instructors guide you through essential Vue.js concepts, including component-based architecture, state management with Vuex, routing with Vue Router, and advanced techniques for building dynamic and interactive web applications. At the Best Training Centre, we prioritize accessibility and inclusivity, ensuring that all learners have the opportunity to excel in harnessing the power of Vue.js. Join us and unlock your Vue.js proficiency with the best training centre"
      },
    ]

    const ReviewData=[
      {
          img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Rihaan",
          date:" july 09 ,2023",
          review:` learnsoft.org has earned a reputation as a leading platform for ${this.props.title} training in ${this.props.location}. Their programs are designed to provide a comprehensive understanding of ${this.props.title} modules, making them a top choice for HR professionals.`
      },
      { img:"/course-img/course-review/learnsoft-logo.webp",
          Username:"Ananya",
          date:" july 29 ,2023",
          review:`${this.props.title}, staying informed about the latest trends, tools, and best practices is essential. learnsoft.org recognizes this need and provides a dedicated section for ${this.props.title} reviews.`
      },
  ]
     return(
      <>
         
          {/* <Mainsec img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="VueJS is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS, and JavaScript and provides a declarative and component-based programming model that helps you efficiently develop user interfaces, be they simple or complex."/>
          */}
                   <NewMainsec rating='4.1' students={"350"} durations={"45"} img={this.props.url} title={this.props.title} location={this.props.location} location1={this.props.location1} intro="VueJS is a JavaScript framework for building user interfaces. It builds on top of standard HTML, CSS, and JavaScript and provides a declarative and component-based programming model that helps you efficiently develop user interfaces, be they simple or complex."/>
            
          <Coursefeature title={this.props.title} location1={this.props.location1}/>
 <section className="pdt50">
		      <Overview heading={`${this.props.title} ${this.props.location1} - Course Overview`} content={`Vue.js ${this.props.location1} is a rapidly growing field with increasing demand for skilled professionals. At Learnsoft.org, we offer high-quality Vue.js training courses in ${this.props.location} to help individuals enhance their skills and gain a comprehensive understanding of Vue.js principles and practices. Our experienced trainers use a hands-on approach, incorporating real-world scenarios and practical exercises to provide a well-rounded education. Whether you're new to Vue.js or looking to expand your skillset, Learnsoft.org's Vue.js ${this.props.location1} is the perfect choice to take your career to the next level. Contact us today to learn more about our courses and start your Vue.js journey.`} 
          title={this.props.title} location={this.props.location} location1={this.props.location1} course={"Our Vue.js course covers a wide range of topics, including Vue.js basics, Vue CLI, Vue components, Vue directives, Vue routing, and Vuex. Our experienced trainers will guide you through hands-on exercises and real-world scenarios to help you understand the concepts and techniques used in Vue.js. By the end of the course, you will be able to implement Vue.js practices in your own projects."}/>
           </section>
          <Batchtime title={this.props.title} fees="25,999" offer="18,999"/>
 <CourseEligibility heading3={`Eligibility requirements for learnsoft's ${this.props.title} Training`} EligibilityData={EligibilityData}/>
 <EnrollnowBox bgimg={"/course-img/Enroll-box-imgs/enroll-bg.webp"} heading4={`Boost Your Career Advancement: Empowering You to Reach New Heights as a ${this.props.title} Developer`}/>
 <Syllabus CurriculumData={course} title={this.props.title}/>
 <div className='df fjse mfdcr mfac'>
 <Coursereview ReviewData={ReviewData}/>
 <div className='df fjc'>
 <LearnSoftLogo/>
 </div>
 </div>
 <Faqs faqData={faqData} heading4={`Answering Your Questions about Learnsoft's ${this.props.title} Course`}/>     
       <Relatedcourse location={this.props.relatedlocation} location1={this.props.location1} url1={this.props.url1} cou7="Java" coupath7="java" cou6='Python' coupath6='python' cou4='Full Stack Developer' coupath4='full-stack-developer' cou='AngularJS' coupath='angularjs' cou3='Front End Developer' coupath3='front-end-developer'
          cou10='R Programming' coupath10='rprogram' cou9='JavaScript' coupath9='javascript' cou1='ReactJS' coupath1='reactjs'
          cou5='TypeScript' coupath5='type-script' cou2='flutter' coupath2='flutter'  cou8='Go' coupath8='go' />

        
      </>
    );
  }
}
